import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { renewalsBulkProducerSchema } from "../renewalsSchemas";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  bulkUpdateProducerCode,
  clearBulkProducerUpdateData,
  clearBulkProducerTargets,
  clearOperationResult,
} from "../../../store/renewal/renewalActions";
import { Button, Col, Divider, Form, Row } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import openNotificationOperationResult from "../../shared/openNotificationOperationResult";
import SearchSelectEx from "../../shared/form/SearchSelectEx";

const initialValues = {
  ProducerCodeKey: null,
};

const BulkUpdateProducerCodeForm = ({
  renewalKeys,
  onCancel,
  targets,
  targetsLoading,
  producerSlot, // 1 or 2
}) => {
  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: initialValues,
    resolver: yupResolver(renewalsBulkProducerSchema),
  });

  //
  const dispatch = useDispatch();

  const loading = useSelector(
    (state) =>
      state.renewal.bulkProducerUpdate[producerSlot]?.loading
  );

  const operationResult = useSelector(
    (state) =>
      state.renewal.bulkProducerUpdate[producerSlot]?.operationResult
  );

  //
  useEffect(() => {
    return () => {
      dispatch(clearBulkProducerUpdateData(producerSlot));
      dispatch(clearBulkProducerTargets(producerSlot));
    };
  }, [dispatch, producerSlot]);

  useEffect(() => {
    if (!operationResult) return;

    openNotificationOperationResult(operationResult, () =>
      dispatch(clearOperationResult())
    );

    if (operationResult.Outcome === "Success") {
      onCancel(true);
    }
  }, [operationResult, dispatch]);

  const onSubmitHandler = (values) => {
    dispatch(
      bulkUpdateProducerCode(
        renewalKeys,
        producerSlot,
        values.ProducerCodeKey
      )
    );
  };

  return (
    <Form
      size="small"
      autoComplete="off"
      onFinish={handleSubmit(onSubmitHandler)}
      colon={false}
      style={{ marginTop: 16 }}
    >
      <Row justify="center">
        <Col span={24}>
          <SearchSelectEx
            name="ProducerCodeKey"
            control={control}
            formLabel={`Producer Code ${producerSlot}`}
            required
            placeholder="Select producer code"
            loading={targetsLoading}
            allowClear
            style={{ width: "100%" }}
            options={targets.map((p) => {
              const code = String(p.ProducerCode ?? "").trim();
              const description = String(p.Description ?? "").trim();

              return {
                value: p.ProducerCodeKey,
                label: code ? `${code} - ${description}` : description,
              };
            })}
          />
        </Col>
      </Row>

      <Divider style={{ marginBottom: 16, marginTop: 16 }} />

      <Row justify="center">
        <Col style={{ paddingRight: "8px" }}>
          <Button
            size="small"
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!isValid || loading}
          >
            <SaveOutlined /> Save
          </Button>
        </Col>

        <Col>
          <Button
            size="small"
            type="dashed"
            onClick={() => onCancel(false)}
          >
            Close
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default BulkUpdateProducerCodeForm;
